var _path, _mask, _g, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCouponEmail = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
  fill: "#BCD9C9"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 8,
  y: 14,
  width: 32,
  height: 24
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.8501 14H39.4501V38H8.8501V14Z",
  fill: "white"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M37.287 36.8182H10.771C9.77711 36.8182 8.97168 35.8397 8.97168 34.6317V16.3051C8.97168 15.0976 9.77711 14.1187 10.771 14.1187H37.287C38.2805 14.1187 39.086 15.0976 39.086 16.3051V34.6317C39.086 35.8397 38.2805 36.8182 37.287 36.8182Z",
  fill: "white"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 15L25 28L39 15",
  stroke: "#EE8322",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 8.75,
  y: 13.75,
  width: 32.5,
  height: 23.5,
  rx: 3.25,
  stroke: "#727D79",
  strokeWidth: 1.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCouponEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-coupon-email.9d19c6cf59f8d9c50f3e17473172fa40.svg";